<template>
    <div class="affairs-list">
        <div class="filter-status">
            <!-- <h5>{{ $t('sort') }}: <b>{{ filter ? $t('notDone(many)') : $t('all') }}</b></h5> -->
        </div>
        <div class="affairs-right-panel">
            <AuthorAffairsList
                :taskList="taskAuthorList"
            ></AuthorAffairsList>
        </div>
    </div>

</template>

<script>
    import VxCard from '@/components/vx-card/VxCard'
    import AuthorAffairsList from '@/components/AuthorTasks/AuthorAffairsList'

    export default {
        name: 'AuthorAffairsSection',
        components: {
            VxCard,
            AuthorAffairsList,
	    },
        props: {
            taskAuthorList: {
            }
        },
    }
</script>

<style lang="scss">

</style>